import {
  NotificationGroupType,
  NotificationRepeat,
  NotificationSendMethod,
  NotificationTrigger,
} from '../../enums/notifications';
import { mockUser } from '../user';

interface INotificationTrigger {
  id: string;
  userId: string;
  trigger: NotificationTrigger;
  repeat: NotificationRepeat | null;
  emailActive: boolean;
  pushActive: boolean;
  dateCreated: string; // iso date string
}

export default INotificationTrigger;

export interface DefaultNotificationSubscription {
  type: NotificationGroupType;
  trigger: NotificationTrigger;
  repeat?: NotificationRepeat;
  sendMethod?: NotificationSendMethod;
}

export const defaultAvailableSubscriptionSets: DefaultNotificationSubscription[] = [
  {
    type: NotificationGroupType.SUMMARY,
    trigger: NotificationTrigger.DASHBOARD_SUMMARY,
    repeat: NotificationRepeat.END_OF_WEEK,
    sendMethod: NotificationSendMethod.EMAIL,
  },
  {
    type: NotificationGroupType.SUMMARY,
    trigger: NotificationTrigger.MISSION_SUMMARY,
    repeat: NotificationRepeat.END_OF_MONTH,
    sendMethod: NotificationSendMethod.EMAIL,
  },
  {
    type: NotificationGroupType.MISSION_BASED,
    trigger: NotificationTrigger.MISSION_SUCCEEDED,
  },
  {
    type: NotificationGroupType.MISSION_BASED,
    trigger: NotificationTrigger.MISSION_SUCCEEDED_WITH_MAINTENANCE,
  },
  {
    type: NotificationGroupType.MISSION_BASED,
    trigger: NotificationTrigger.MISSION_FAILED,
  },
  {
    type: NotificationGroupType.ORGANIZATION_BASED,
    trigger: NotificationTrigger.API_EXPIRING,
  },
];

// mock data

export const mockNotificationSubscription: INotificationTrigger = {
  id: 'someId',
  emailActive: true,
  pushActive: false,
  dateCreated: '2024-09-08T23:59:99',
  repeat: null,
  trigger: NotificationTrigger.MISSION_SUCCEEDED_WITH_MAINTENANCE,
  userId: mockUser.id,
};
